import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { LandingBlockTypes, blockWithSettings, moderationState } from "@/const";
import { useRequest } from "@components/AppHook";
import { DndTable } from "@components/DND";
import { DevForm } from "@components/Forms/Fields";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function LandingBlockGamesScreen() {
    const { t } = useTranslation();
    const { slug, selection_id, block_id } = useParams();
    const apiUrl = url_reverse("api:landing:block:games", { selection_id, block_id });
    const { apiData, setApiData } = useAppApi(apiUrl);
    const [selectedGame, setSelectedGame] = useState([]);
    const navigate = useNavigate();
    const { api_post } = useRequest();

    if (!apiData) return;

    const settingUrl = apiData.setting
        ? url_reverse("admin:event:landing_block:settings:item", {
              slug,
              selection_id,
              block_id,
              id: apiData.setting.id,
          })
        : url_reverse("admin:event:landing_block:settings", { slug, selection_id, block_id });

    const deleteSelected = (ev) => {
        api_post(ev, apiUrl, {
            params: {
                action: "delete_block_items",
                ids: selectedGame,
            },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                }
            },
        });
    };
    const header = (
        <>
            <Link to={url_reverse("admin:event:landing", { slug, selection_id })}>{t("Блоки лендинга")}</Link>
            <span> – </span>
            {LandingBlockTypes[apiData.block.scheme]}
        </>
    );
    const headerTools = (
        <>
            {blockWithSettings.includes(apiData.block.scheme) && (
                <Button size="sm" variant="dark" onClick={() => navigate(settingUrl)}>
                    {t("Поля блока")}
                </Button>
            )}{" "}
            {selectedGame.length > 0 && (
                <DevForm.Button size="sm" variant="dark" name="delsel" onClick={deleteSelected}>
                    {t("Удалить")}
                </DevForm.Button>
            )}
        </>
    );

    return (
        <DefaultLayout>
            <ListingCard header={header} headerTools={headerTools}>
                {apiData.block.scheme === "banner" && (
                    <Alert variant="warning">
                        {"Если игра добавлена в данный блок, то баннер в карточке игры у нее не отображается."}
                    </Alert>
                )}
                <BlockListSortable
                    apiData={apiData}
                    setApiData={setApiData}
                    apiUrl={apiUrl}
                    selectedGame={selectedGame}
                    setSelectedGame={setSelectedGame}
                />
            </ListingCard>
        </DefaultLayout>
    );
}

function BlockListSortable({ apiData, setApiData, apiUrl, selectedGame, setSelectedGame }) {
    const { t } = useTranslation();
    const [allSelected, setAllSelected] = useState(false);
    const { slug } = useParams();

    const handleSelectAll = () => {
        if (allSelected) {
            setAllSelected(false);
            setSelectedGame([]);
        } else {
            setAllSelected(true);
            setSelectedGame(apiData.object_list.map((el) => el.id));
        }
    };

    const handleCheckBoxChange = (id) => {
        if (selectedGame.includes(id)) {
            setSelectedGame(selectedGame.filter((el) => el !== id));
        } else {
            setSelectedGame([...selectedGame, id]);
        }
    };
    const prepareTooltip = (data) => {
        if (data) {
            return data.map((el) => {
                return <div key={el.id}> {LandingBlockTypes[el.value]}</div>;
            });
        }
    };

    return (
        <DndTable
            apiData={apiData}
            setApiData={setApiData}
            apiUrl={apiUrl}
            ths={
                <>
                    <th>{t("Игра")}</th>
                    <th>{t("Участие")}</th>
                    <th>{t("Материалы")}</th>
                    <th>{t("Готов к размещению")}</th>
                    <th>
                        <DevForm.Checkbox checked={allSelected} onChange={handleSelectAll} />
                    </th>
                </>
            }
            tds={(el) => (
                <>
                    <td>
                        <Link
                            to={url_reverse("admin:event:landing_block:edit_game", {
                                slug,
                                selection_id: apiData.selection.id,
                                block_id: apiData.block.id,
                                selection_item_id: el.selection_item.id,
                            })}
                        >
                            {el.game.base_locale_object.name}
                        </Link>{" "}
                        <Awesome type="info-circle" tooltip={prepareTooltip(el.__game_in_blocks)} />
                    </td>
                    <td>{el.selection_item.moderation_state === "material_request" ? t("Не принял") : t("Принял")}</td>
                    <td>{moderationState[el.selection_item.moderation_state]}</td>
                    <td>
                        {el.game.publication_state === "done" && el.selection_item.moderation_state === "review_passed"
                            ? t("Да")
                            : t("Нет")}
                    </td>
                    <td>
                        <DevForm.Checkbox
                            checked={selectedGame.includes(el.id)}
                            onChange={() => handleCheckBoxChange(el.id)}
                        />
                    </td>
                </>
            )}
        />
    );
}
